import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface Props {
  title?: string;
  description?: string;
}

export function BlogCTA({ title, description }: Props = {}) {
  const heading = title?.trim() || "See Youtemp in action";
  const body =
    description?.trim() ||
    "Built for UK agencies, employers and workers managing temporary staffing workflows.";
  return (
    <section
      aria-label="Call to action"
      className="mt-14 rounded-3xl p-8 sm:p-10 shadow-lg bg-gradient-to-br from-secondary via-secondary to-primary text-secondary-foreground"
    >
      <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight mb-3 text-secondary-foreground">
        {heading}
      </h2>
      <p className="text-base sm:text-lg text-secondary-foreground/80 leading-relaxed mb-6 max-w-2xl">
        {body}
      </p>
      <div className="flex flex-wrap gap-3">
        <Link
          to="/waitlist/"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-primary text-primary-foreground font-semibold hover:opacity-90 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          Join the waitlist <ArrowRight className="h-4 w-4" />
        </Link>
        <Link
          to="/demo/"
          className="inline-flex items-center h-11 px-5 rounded-full border border-secondary-foreground/30 text-secondary-foreground font-semibold hover:bg-secondary-foreground/10 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          Request a demo
        </Link>
      </div>
    </section>
  );
}